import React from 'react';
import { SectionTable } from '../../../store/sections/types';
import {
  DataTable,
  IconPencil,
  IconTrash,
} from '@skf/bt-wind-rail-commonlibrary';
import style from './SectionManagement.module.scss';

interface SectionManagementTableProps {
  sections: SectionTable[];
  onEditClick: (section: SectionTable) => void;
  onDeleteClick: (section: SectionTable) => void;
}
type RowType = {
  row: {
    original: SectionTable;
  };
};
export const SectionManagementTable: React.FunctionComponent<SectionManagementTableProps> = ({
  sections,
  onDeleteClick,
  onEditClick,
}) => {
  const columns: any = [
    {
      Header: 'Industry',
      accessor: 'industry',
      className: style.column,
    },
    {
      Header: 'PortalName',
      accessor: 'portalName',
      className: style.column,
    },
    {
      Header: 'Websection parent name',
      accessor: 'webSectionParentName',
      className: style.column,
    },
    {
      Header: 'Websection displayname',
      accessor: 'webSectionDisplayName',
      className: style.column,
    },
    {
      Header: 'Websection URL',
      accessor: 'webSectionURL',
      className: style.column,
    },
    {
      Header: 'PowerBI report name',
      accessor: 'powerBIReportName',
      className: style.column,
    },
    {
      Header: '',
      accessor: 'Action',
      disableSortBy: true,
      className: style.columnActions,
      Cell: ({ row }: RowType) => {
        const original = row.original;
        return (
          <div className={style.iconsColumns}>
            <IconPencil
              className={style.cursorPointer}
              onClick={() => onEditClick(original)}
            />
            <IconTrash
              className={style.cursorPointer}
              onClick={() => {
                onDeleteClick(original);
              }}
            />
          </div>
        );
      },
    },
  ];

  return (
    <DataTable
      columns={columns}
      data={sections}
      className={style.table}
      pagination={20}
    />
  );
};
